module.exports = __webpack_public_path__ + "static/media/Mica.fad6795b.png";